import { createContext, useContext } from "react";

// Generic context for popover-like containers (Popover, Select, etc.)
// This allows tooltips to render within the container rather than at document root
export const PopoverContainerContext = createContext<HTMLDivElement | null>(null);

export const usePopoverContainer = (): HTMLDivElement | null => {
  return useContext(PopoverContainerContext);
};
